import countryCodeMap from "../data/country_code_map.json";

export default function getFullAddress(customer) {
  if (customer) {
    return `${customer.street_address}, ${customer.city}, ${customer.state}, ${customer.zip_code}, ${countryCodeMap[customer.country]}`;
  }
  return "";
}
